import {
    baseStates,
    baseMutations,
    baseActions,
    baseGetters,
} from '@/stores/base';

export const companyEquipment = {

    namespaced: true,

    state:
    {
        ...baseStates,

        url: '/equipments',

        branches: [],
        branchesLoading: false,

        equipmentCategories: [],
        equipmentCategoriesLoading: false,
        equipmentCategory: false,
    },

    mutations:
    {
        ...baseMutations,
    },

    actions:
    {
        ...baseActions,
    },

    getters:
    {
        ...baseGetters,

        branches: state => state.branches,
        
        equipmentCategories: state => state.equipmentCategories,
    },
};
